























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { DateTime } from 'luxon'
import moment from 'moment'
import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import FileSaver from 'file-saver'
import HistoricoSituacaoStore from '@/components/HistoricoSituacao/Store/HistoricoSituacaoStore'
import { formatDateOnly, maskMoney, timeoutDefault, displayColorPrestadorRecebimentoBySituation, maskCPFCNPJ, onlyNumber, maskDate, timeout } from '@/utils/common'
import { StatusSlaEnum, IRequestMessage, RequestMessage, Loading, PrestadorRecebimento, SituacaoRemuneracaoEnum, DataTablePagination } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import SelectFontesPagadoras from '@/components/RemuneracaoMedica/financeiro/components/select-fontes-pagadoras.vue'

@Component({
  components: {
    SelectFontesPagadoras,
  },
})
export default class ViewFinanceiro extends Vue {
  /**
   * Seleção do modal "Exportar registros". Fica em estado local da view (e não na
   * FinanceiroStore) porque `fontePagadoraId` é compartilhado com a listagem,
   * "Finalizar processos" e demais payloads da tela — não pode virar lista.
   */
  fontesPagadorasExportarRegistros: string[] = []

  async updatePagination(pagination: DataTablePagination) {
    this.loadingNotasFiscais = true
    let param = ''
    if (pagination.sortBy) {
      param = pagination.descending ? `${pagination.sortBy}Desc` : `${pagination.sortBy}Asc`
    } else {
      param = ''
    }
    this.getFinanceiroStore.setSortBy(param)
    await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
    this.loadingNotasFiscais = false
  }

  $refs!: {
    dateA: any,
    dateB: any,
    dateC: any,
    dateD: any,
    dateE: any,
    dataNotificacaoForm: any,
    dataNovoPrazoProvisionamento: any,
    provisionadaNovaDataEnvioNota: any,
    provisionadaNovaDataPagamento: any,
    menuExportarRegistros: any,
    formExportarRegistros: any,
    dataNovaPrevisaoPagamento: any,
    menu: any,
    formAnoMesReferencia: any,
    formFinalizarProcessos: any,
    formNumeroChamado: any,
    tablePrestadores: any,
  }

  sel: any = {}
  menu: boolean = false
  menuFinalizarProcessos: boolean = false
  exp: boolean = false
  modalAtualizarNotaFiscalDisabled: boolean = false
  modalEnviarNotificacaoDeCobranca: boolean = false
  menuExportarRegistros: boolean = false
  loadExportacaoRegistros: boolean = false
  loadSearch: boolean = false
  loadAtualizarNotaFiscal: string = ''
  loadVisualizarNotaFiscal: string = ''
  loadProvisionarRemuneracao: string = ''
  loadCancelarProvisionamento: string = ''
  loadAlterarPrestador: string = ''
  loadSearchPrestador: boolean = false
  loadAlterarSituacoesEmLote: boolean = false
  loadAlterarPrestadorConfirmar: boolean = false
  loadDeleteRepasse: boolean = false
  loadDeletarNotaFiscal: string = ''
  loadNotificarPrestador: string = ''
  loadProvisionarConfirmar: boolean = false
  loadCancelarProvisionamentoConfirmar: boolean = false
  loadDeletarConfirmar: boolean = false
  loadNotificarConfirmar: boolean = false
  loadEmitirRelatorio: boolean = false
  loadNumeroChamado: boolean = false
  loadAgrupamentoPrestador: boolean = false
  loadLiberarRepasses: boolean = false
  loadDocumentoByPrestadorRecebimentoId: boolean = false
  loadNotasFiscais: boolean = false
  loadVisualizarItens: string = ''
  loadEnviarNotificacao: boolean = false
  loadModalEnviarNotificacao: boolean = false

  step: number = 1

  loadingReq: Loading = {
    status: false,
    text: '',
  }

  getRequestMessage: IRequestMessage = new RequestMessage()
  modalProvisionarRemuneracao: boolean = false
  modalCancelarProvisionamento: boolean = false
  modalAlterarPrestador: boolean = false
  modalVisualizarItens: boolean = false
  modalDeletarNotaFiscal: boolean = false
  modalDeleteRepasse: boolean = false
  modalNotificarPrestador: boolean = false
  modalAgruparRepasses: boolean = false
  modalExportarRegistros: boolean = false
  modalLiberarRepasses: boolean = false
  modalAlterarSituacoesEmLote: boolean = false
  modalValidacaoResultado: boolean = false
  dateText1: string = ''
  prestador: string = ''
  dateText2: string = ''
  dateText3: string = ''
  dateText4: string = ''
  dateText5: string = ''
  dataUltimaNotificacao: string = ''
  novoPrazoNota: string = ''
  previsaoPagamento: string = ''
  novoPrazoNotaProvisionada: string = ''
  previsaoPagamentoProvisionada: string = ''
  dataPrazoEnvioNota: string = ''
  loadValores: boolean = false
  valoresList: boolean = false
  loadHistorico: string = ''
  loadValidacaoResultado: string = ''
  loadOpenModalDelete: string = ''
  informarEmail: boolean = false
  showLeft: boolean = false
  showRight: boolean = true

  dataNotificacaoRules: any = {
    valid: true,
    dataNotificacao: [
      v => !!v || 'O campo é obrigatório.',
    ],
  }

  dataNovoPrazoRules: any = {
    valid: true,
    dataNovoPrazo: [
      v => !!v || 'O campo é obrigatório.',
    ],
  }

  dataNovoPrazoRulesProvisionada: any = {
    valid: true,
    dataNovoPrazoProvisionada: [
      v => !!v || 'O campo é obrigatório.',
    ],
  }

  dataPrevisaoPagamentoRulesProvisionada: any = {
    valid: true,
    dataPrevisaoPagamentoProvisionada: [
      v => !!v || 'O campo é obrigatório.',
    ],
  }

  dataPrevisaoPagamentoRules: any = {
    valid: true,
    dataPrevisaoPagamentoProvisionar: [
      v => !!v || 'O campo é obrigatório.',
    ],
  }

  anoMesReferenciaRules: any = {
    valid: true,
    dataRepasse: [
      v => !!v || 'O campo é obrigatório.',
    ],
    fontePagadoraId: [
      v => !!v || 'O campo é obrigatório.',
    ],
  }

  numeroChamadoRules: any = {
    valid: true,
    numeroChamado: [
      v => !!v || 'O campo é obrigatório.',
    ],
  }

  exportarRegistrosRules: any = {
    valid: true,
    anoMesReferenciaExportarRegistros: [
      v => !!v || 'O campo é obrigatório.',
    ],
    fontesPagadorasExportarRegistros: [
      v => (Array.isArray(v) && v.length > 0) || 'O campo é obrigatório.',
    ],
  }

  buscarPrestadorTableHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Prestador', value: 'nome', sortable: false },
    { text: 'CNPJ', value: 'documento', sortable: false },
    { text: 'Cod. His', value: 'codHis', sortable: false },
  ]

  getResultColor(result) {
      return result === 'Divergente' ? 'red' : result === 'Valida' ? 'green' : 'inherit'
    }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  get colunasOcultarItems() {
    return this.getFinanceiroStore.colunasOcultarItems
  }

  get podeEncerrarRepasses() {
    return this.getFinanceiroStore.enablePodeEncerrarRepasses
  }

  get exibirOpcaoRelatorioAssinaturaDiretoria() {
    return this.getFinanceiroStore.exibirOpcaoRelatorioAssinaturaDiretoria
  }

  get prestadorRecebimento() {
    return this.getFinanceiroStore.prestadorRecebimento
  }

  get loadingValores() {
    return this.loadValores
  }

  set loadingValores(value: boolean) {
    this.loadValores = value
  }

  get loadingNotasFiscais() {
    return this.loadNotasFiscais
  }

  set loadingNotasFiscais(value: boolean) {
    this.loadNotasFiscais = value
  }

  get loadingAgrupamentoPrestador() {
    return this.loadAgrupamentoPrestador
  }

  set loadingAgrupamentoPrestador(value: boolean) {
    this.loadAgrupamentoPrestador = value
  }

  get loadingLiberarRepasses() {
    return this.loadLiberarRepasses
  }

  set loadingLiberarRepasses(value: boolean) {
    this.loadLiberarRepasses = value
  }

  get loadingExportacaoRegistros() {
    return this.loadExportacaoRegistros
  }

  set loadingExportacaoRegistros(value: boolean) {
    this.loadExportacaoRegistros = value
  }

  get loadingVisualizarItens() {
    return this.loadVisualizarItens
  }

  set loadingVisualizarItens(value: string) {
    this.loadVisualizarItens = value
  }

  get loadingEnviarNotificacao() {
    return this.loadEnviarNotificacao
  }

  get exibirNumeroChamado() {
    return this.getFinanceiroStore.exibirNumeroChamado
  }

  set loadingEnviarNotificacao(value: boolean) {
    this.loadEnviarNotificacao = value
  }

  get loadingModalEnviarNotificacao() {
    return this.loadModalEnviarNotificacao
  }

  set loadingModalEnviarNotificacao(value: boolean) {
    this.loadModalEnviarNotificacao = value
  }

  get loadingDocumentoByPrestadorRecebimentoId() {
    return this.loadDocumentoByPrestadorRecebimentoId
  }

  set loadingDocumentoByPrestadorRecebimentoId(value: boolean) {
    this.loadDocumentoByPrestadorRecebimentoId = value
  }

  get loadingNumeroChamado() {
    return this.loadNumeroChamado
  }

  set loadingNumeroChamado(value: boolean) {
    this.loadNumeroChamado = value
  }

  get showModalAgruparRepasses() {
    return this.modalAgruparRepasses
  }

  set showModalAgruparRepasses(value: boolean) {
    this.modalAgruparRepasses = value
  }

  get showModalExportarRegistros() {
    return this.modalExportarRegistros
  }

  set showModalExportarRegistros(value: boolean) {
    this.modalExportarRegistros = value
  }

  get showModalLiberarRepasses() {
    return this.modalLiberarRepasses
  }

  set showModalLiberarRepasses(value: boolean) {
    this.modalLiberarRepasses = value
  }

  get getModalAtualizarNotaFiscalDisabled() {
    return this.modalAtualizarNotaFiscalDisabled
  }

  set getModalAtualizarNotaFiscalDisabled(value: boolean) {
    this.modalAtualizarNotaFiscalDisabled = value
  }

  get situacao() {
    return this.getFinanceiroStore.situacoes || []
  }

  set situacao(value: any) {
    this.getFinanceiroStore.setSituacoes(value.key)
  }

  get loadingNotificarConfirmar() {
    return this.loadNotificarConfirmar
  }

  set loadingNotificarConfirmar(value: boolean) {
    this.loadNotificarConfirmar = value
  }

  get loadingEmitirRelatorio() {
    return this.loadEmitirRelatorio
  }

  set loadingEmitirRelatorio(value: boolean) {
    this.loadEmitirRelatorio = value
  }

  get loadingProvisionarConfirmar() {
    return this.loadProvisionarConfirmar
  }

  set loadingProvisionarConfirmar(value: boolean) {
    this.loadProvisionarConfirmar = value
  }

  get loadingCancelarProvisionamentoConfirmar() {
    return this.loadCancelarProvisionamentoConfirmar
  }

  set loadingCancelarProvisionamentoConfirmar(value: boolean) {
    this.loadCancelarProvisionamentoConfirmar = value
  }

  get loadingDeletarConfirmar() {
    return this.loadDeletarConfirmar
  }

  set loadingDeletarConfirmar(value: boolean) {
    this.loadDeletarConfirmar = value
  }

  get loadingNotificarPrestador() {
    return this.loadNotificarPrestador
  }

  set loadingNotificarPrestador(value: string) {
    this.loadNotificarPrestador = value
  }

  get getFontePagadoras() {
    return this.getRecebimentoStore.fontePagadoras
  }

  get getGrupoRepasseItensExportarRegistros() {
    return this.getFinanceiroStore.grupoRepasseItens
  }

  set getGrupoRepasseItensExportarRegistros(value: any[]) {
    this.getFinanceiroStore.grupoRepasseItens = value
  }

  get layoutRelatorio() {
    return this.getFinanceiroStore.layoutRelatorio
  }

  set layoutRelatorio(value: boolean | null) {
    this.getFinanceiroStore.setLayoutRelatorio(value)
  }

  get getMenuExportarRegistros() {
    return this.menuExportarRegistros
  }

  set getMenuExportarRegistros(value: boolean) {
    this.menuExportarRegistros = value
  }

  get anoMesReferenciaExportarRegistros() {
    return this.getFinanceiroStore.anoMesReferenciaExportarRegistros
  }

  set anoMesReferenciaExportarRegistros(value) {
    this.getFinanceiroStore.setAnoMesReferenciaExportarRegistros(value)
  }

  get relatorioSelected() {
    return this.getFinanceiroStore.relatorioSelected
  }

  set relatorioSelected(value: string) {
    this.getFinanceiroStore.setRelatorioSelected(value)
  }

  get getGrupoRepasseItensFinalizarProcessos() {
    return this.getFinanceiroStore.grupoRepasseItens
  }

  set getGrupoRepasseItensFinalizarProcessos(value: any[]) {
    this.getFinanceiroStore.grupoRepasseItens = value
  }

  get fontePagadoraId() {
    return this.getFinanceiroStore.fontePagadoraId
  }

  set fontePagadoraId(value: string) {
    this.getFinanceiroStore.setFontePagadoraId(value)
  }

  get situacoesExportarRegistros() {
    return this.getFinanceiroStore.situacoesExportarRegistros
  }

  set situacoesExportarRegistros(value: string) {
    this.getFinanceiroStore.setSituacoesExportarRegistros(value)
  }

  get fontePagadoraIdFinalizarProcessos() {
    return this.getFinanceiroStore.fontePagadoraId
  }

  set fontePagadoraIdFinalizarProcessos(value: string) {
    this.getFinanceiroStore.setFontePagadoraIdFinalizarProcessos(value)
  }

  get grupoRepasseExportarRegistros() {
    return this.getFinanceiroStore.grupoRepasse
  }

  set grupoRepasseExportarRegistros(value: string) {
    this.getFinanceiroStore.setGrupoRepasseExportarRegistros(value)
  }

  get grupoRepasseFinalizarProcessos() {
    return this.getFinanceiroStore.grupoRepasse
  }

  set grupoRepasseFinalizarProcessos(value: string) {
    this.getFinanceiroStore.setGrupoRepasseFinalizarProcessos(value)
  }

  get loadingProvisionarRemuneracao() {
    return this.loadProvisionarRemuneracao
  }

  set loadingProvisionarRemuneracao(value: string) {
    this.loadProvisionarRemuneracao = value
  }

  get loadingCancelarProvisionamento() {
    return this.loadCancelarProvisionamento
  }

  set loadingCancelarProvisionamento(value: string) {
    this.loadCancelarProvisionamento = value
  }

  get loadingAlterarPrestador() {
    return this.loadAlterarPrestador
  }

  set loadingAlterarPrestador(value: string) {
    this.loadAlterarPrestador = value
  }

  get loadingSearchPrestador() {
    return this.loadSearchPrestador
  }

  set loadingSearchPrestador(value: boolean) {
    this.loadSearchPrestador = value
  }

  get loadingAlterarSituacoesEmLote() {
    return this.loadAlterarSituacoesEmLote
  }

  set loadingAlterarSituacoesEmLote(value: boolean) {
    this.loadAlterarSituacoesEmLote = value
  }

  get loadingAlterarPrestadorConfirmar() {
    return this.loadAlterarPrestadorConfirmar
  }

  set loadingAlterarPrestadorConfirmar(value: boolean) {
    this.loadAlterarPrestadorConfirmar = value
  }

  get loadingDeleteRepasse() {
    return this.loadDeleteRepasse
  }

  set loadingDeleteRepasse(value: boolean) {
    this.loadDeleteRepasse = value
  }

  get loadingDeletarNotaFiscal() {
    return this.loadDeletarNotaFiscal
  }

  set loadingDeletarNotaFiscal(value: string) {
    this.loadDeletarNotaFiscal = value
  }

  get selected() {
    return this.sel
  }

  set selected(value: any) {
    this.sel = value
  }

  get expand() {
    return this.exp
  }

  set expand(value: boolean) {
    this.exp = value
  }

  get loadingSearch() {
    return this.loadSearch
  }

  set loadingSearch(value: boolean) {
    this.loadSearch = value
  }

  get getMenu() {
    return this.menu
  }

  set getMenu(value: boolean) {
    this.menu = value
  }

  get getMenuFinalizarProcessos() {
    return this.menuFinalizarProcessos
  }

  set getMenuFinalizarProcessos(value: boolean) {
    this.menuFinalizarProcessos = value
  }

  get loadingAtualizarNotaFiscal() {
    return this.loadAtualizarNotaFiscal
  }

  set loadingAtualizarNotaFiscal(value: string) {
    this.loadAtualizarNotaFiscal = value
  }

  get loadingVisualizarNotaFiscal() {
    return this.loadVisualizarNotaFiscal
  }

  set loadingVisualizarNotaFiscal(value: string) {
    this.loadVisualizarNotaFiscal = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: string) {
    this.loadHistorico = value
  }

  get loadingValidacaoResultado() {
    return this.loadValidacaoResultado
  }

  set loadingValidacaoResultado(value: string) {
    this.loadValidacaoResultado = value
  }

  get loadingOpenModalDelete() {
    return this.loadOpenModalDelete
  }

  set loadingOpenModalDelete(value: string) {
    this.loadOpenModalDelete = value
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get anoMesReferencia() {
    return this.getFinanceiroStore.anoMesReferencia
  }

  set anoMesReferencia(value) {
    this.getFinanceiroStore.setAnoMesReferencia(value)
  }

  get anoMesReferenciaListaRepasse() {
    return this.getFinanceiroStore.anoMesReferenciaListaRepasse
  }

  set anoMesReferenciaListaRepasse(value) {
    this.getFinanceiroStore.setAnoMesReferenciaListaRepasse(value)
  }

  get anoMesReferenciaFinalizarProcessos() {
    return this.getFinanceiroStore.anoMesReferenciaFinalizarProcessos
  }

  set anoMesReferenciaFinalizarProcessos(value) {
    this.getFinanceiroStore.setAnoMesReferenciaFinalizarProcessos(value)
  }

  get headers() {
    return this.getFinanceiroStore.notasFiscaisTableHeader || []
  }

  get filteredItems() {
    const filtered = this.headers.filter(header => !this.colunasOcultarItems.some(hiddenField => hiddenField.toLowerCase() === header.value.toLowerCase()))

    return filtered
  }

  get backofficeVisualizarItensHeaders() {
    return this.getFinanceiroStore.backofficeVisualizarItensHeaders || []
  }

  get notasFiscais() {
    // Garantir array para evitar erros de length quando nulo
    return this.getFinanceiroStore.prestadoresRecebimentos || []
  }

  get itensDoRepasse() {
    // Evitar nulo; pelo menos garantir itens como array vazio
    return this.getFinanceiroStore.itensDoRepasse || { itens: [] }
  }

  get numeroChamado() {
    return this.getFinanceiroStore.numeroChamado
  }

  set numeroChamado(value: string) {
    this.getFinanceiroStore.setNumeroChamado(value)
  }

  get email() {
    return this.getFinanceiroStore.email
  }

  set email(value: string) {
    this.getFinanceiroStore.setEmail(value)
  }

  get getTotal() {
    return this.getFinanceiroStore.totalPrestadorRemuneracao || 0
  }

  get getTotalRepasseItems() {
    return this.getFinanceiroStore.totalRepasseItems || 0
  }

  get remuneracaoLength() {
    return Math.ceil(this.getTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  get itemsLength() {
    return Math.ceil(this.getTotalRepasseItems / this.getFinanceiroStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

  get getPageItems() {
    return this.getFinanceiroStore.pageItems
  }

  set getPageItems(value: number) {
    this.getFinanceiroStore.setPageItems(value)
  }

  get drawer() {
    return this.getFinanceiroStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getFinanceiroStore.setFilterDrawer(value)
  }

  get getDateText1() {
    this.dateText1 = this.formatISOToDate(this.dataUltimaNotificacao)
    return this.dateText1
  }

  set getDateText1(value: string | Date) {
    this.dateText1 = this.formatISOToDate(this.dataUltimaNotificacao)
  }

  get getDateText2() {
    this.dateText2 = this.formatISOToDate(this.novoPrazoNota)
    return this.dateText2
  }

  set getDateText2(value: string | Date) {
    this.dateText2 = this.formatISOToDate(this.novoPrazoNota)
  }

  get getDateText3() {
    this.dateText3 = this.formatISOToDate(this.previsaoPagamento)
    return this.dateText3
  }

  set getDateText3(value: string | Date) {
    this.dateText3 = this.formatISOToDate(this.previsaoPagamento)
  }

  get getDateText4() {
    this.dateText4 = this.formatISOToDate(this.novoPrazoNotaProvisionada)
    return this.dateText4
  }

  set getDateText4(value: string | Date) {
    this.dateText4 = this.formatISOToDate(this.novoPrazoNotaProvisionada)
  }

  get getDateText5() {
    this.dateText5 = this.formatISOToDate(this.previsaoPagamentoProvisionada)
    return this.dateText5
  }

  set getDateText5(value: string | Date) {
    this.dateText5 = this.formatISOToDate(this.previsaoPagamentoProvisionada)
  }

  get prestadores() {
    return this.getFinanceiroStore.prestadoresLista
  }

  get situacoes() {
    return [
      { key: 'Pendente', display: 'Pendente', quantidade: this.getSituacaoPendenteTotal },
      { key: 'Divergente', display: 'Divergente', quantidade: this.getDivergenteTotal },
      { key: 'Provisionada', display: 'Provisionada', quantidade: this.getProvisionadaTotal },
      { key: 'ValidacaoPendente', display: 'Validação pendente', quantidade: this.getValidacaoPendenteTotal },
      { key: 'Validada', display: 'Validada', quantidade: this.getValidadaTotal },
      { key: 'Paga', display: 'Paga', quantidade: this.getPagaTotal },
      { key: 'EnviadoParaPagamento', display: 'Enviado para pagamento', quantidade: this.getEnviadoParaPagamentoTotal },
    ]
  }

  get agrupamentoRpas() {
    return this.getFinanceiroStore.agrupamentoRpas
  }

  set agrupamentoRpas(value) {
    this.getFinanceiroStore.setAgrupamentoRpas(value)
  }

  get getSituacaoPendenteTotal() {
    const filter = this.getFinanceiroStore.situacoesFiltro.filter(c => c.key === SituacaoRemuneracaoEnum.Pendente)[0]
    if (filter) {
      return filter.total
    }

    return 0
  }

  get getEnviadoParaPagamentoTotal() {
    const filter = this.getFinanceiroStore.situacoesFiltro.filter(c => c.key === SituacaoRemuneracaoEnum.EnviadoParaPagamento)[0]
    if (filter) {
      return filter.total
    }

    return 0
  }

  get getDivergenteTotal() {
    const filter = this.getFinanceiroStore.situacoesFiltro.filter(c => c.key === SituacaoRemuneracaoEnum.Divergente)[0]
    if (filter) {
      return filter.total
    }

    return 0
  }

  get getProvisionadaTotal() {
    const filter = this.getFinanceiroStore.situacoesFiltro.filter(c => c.key === SituacaoRemuneracaoEnum.Provisionada)[0]
    if (filter) {
      return filter.total
    }

    return 0
  }

  get getValidacaoPendenteTotal() {
    const filter = this.getFinanceiroStore.situacoesFiltro.filter(c => c.key === SituacaoRemuneracaoEnum.ValidacaoPendente)[0]
    if (filter) {
      return filter.total
    }

    return 0
  }

  get getValidadaTotal() {
    const filter = this.getFinanceiroStore.situacoesFiltro.filter(c => c.key === SituacaoRemuneracaoEnum.Validada)[0]
    if (filter) {
      return filter.total
    }

    return 0
  }

  get getPagaTotal() {
    const filter = this.getFinanceiroStore.situacoesFiltro.filter(c => c.key === SituacaoRemuneracaoEnum.Paga)[0]
    if (filter) {
      return filter.total
    }

    return 0
  }

  get valoresListDialog() {
    return this.valoresList
  }

  set valoresListDialog(value: boolean) {
    this.valoresList = value
  }

  get solicitacaoId() {
    return this.getFinanceiroStore.solicitacaoId
  }

  set solicitacaoId(value: string) {
    this.getFinanceiroStore.solicitacaoIdRepasse(value)
  }

  get profissional(){
    return this.getFinanceiroStore.profissional;
  }

  maskCPFCNPJUtil(value: string) {
    return maskCPFCNPJ(value)
  }

  formatDate(date: string) {
    return maskDate(date)
  }

  formatDateTimeUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async getValoresCalculados() {
    this.loadingValores = true
    await timeout(300)
    this.valoresListDialog = true
    this.loadingValores = false
  }

  closeValoresListDialog() {
    this.valoresListDialog = false
  }

  async showModalVisualizarItens(id: string) {
    this.loadingVisualizarItens = id
    await this.getFinanceiroStore.getItensDoRepasse(id)
    this.modalVisualizarItens = true
    this.loadingVisualizarItens = ''
  }

  closeModalVisualizarItens() {
    this.getFinanceiroStore.clearItensDoRepasse()
    this.getFinanceiroStore.setPageItems(1)
    this.modalVisualizarItens = false
  }

  async copyUploadNotaFiscal(text: any) {
    const copyValue = document.createElement('input')
    copyValue.value = text
    document.body.appendChild(copyValue)
    copyValue.select()
    try {
      document.execCommand('copy')
      EventBus.$emit('setSnackbar', { show: true, text: 'Link copiado para a área de transferencia!', icon: 'done', color: '#2E7D32' })
    } catch (err) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível copiar o link', icon: 'warning', color: '#C62828' })
    }
    document.body.removeChild(copyValue)
    this.ga('backoffice-financeiro', 'copiar-link-upload-nota-fiscal')
  }

  async enviarNotificacaoDeCobranca(recebimento: PrestadorRecebimento) {
    this.loadingEnviarNotificacao = true
    let params: any = {}

    if (this.informarEmail) {
      params = {
        prestadorRecebimentoId: recebimento.id,
        emailNotificacao: this.email,
      }
    } else {
      params = {
        prestadorRecebimentoId: recebimento.id,
      }
    }
    const response = await this.getFinanceiroStore.enviarNotificacaoDeCobranca(params)

    if (response.success) {
      this.modalEnviarNotificacaoDeCobranca = false
      EventBus.$emit('setSnackbar', { show: true, text: 'Email de cobrança enviado com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível enviar o email de cobrança', icon: 'warning', color: '#C62828' })
    }

    this.loadingEnviarNotificacao = false
    this.ga('backoffice-financeiro', 'enviar-notificacao-de-cobranca')
  }

  async openExcel(params: any) {
    const link = document.createElement('a')
    link.href = params.url
    link.download = decodeURIComponent(params.nome)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  closeWindow() {
    window.close()
  }

  clearDate() {
    this.dataUltimaNotificacao = ''
  }

  clearDateProvisionar(elements: string[]) {
    this.novoPrazoNota = ''
    this.previsaoPagamento = ''
  }

  clearDateProvisionada(elements: string[]) {
    this.novoPrazoNotaProvisionada = ''
    this.previsaoPagamentoProvisionada = ''
  }

  clickDateTime(event) {
    this.$refs.dateA.open(event)
  }

  clickDateTimeNovoPrazoProvisionamento(event) {
    this.$refs.dateB.open(event)
  }

  clickDateTimePrevisaoPagamentoProvisionamento(event) {
    this.$refs.dateC.open(event)
  }

  clickDateTimeProvisionadaNovaData(event) {
    this.$refs.dateD.open(event)
  }

  clickDateTimeProvisionadaPrevisaoPagamento(event) {
    this.$refs.dateE.open(event)
  }

  formatISOToDate(value: string | Date) {
    if (value === '') return value
    return DateTime.fromISO(value).toLocaleString(DateTime.DATE_SHORT)
  }

  async criarAgrupamentoPrestadorRecebimento() {
    this.loadingAgrupamentoPrestador = true
    if (this.$refs.formAnoMesReferencia.validate()) {
      const response: any = await this.getFinanceiroStore.criarAgrupamentoPrestadorRecebimento()
      if (response.success) {
        this.step = 2
        this.$refs.formNumeroChamado.reset()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message ? response.message : 'Ocorreu um erro ao agrupar o repasse.', icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingAgrupamentoPrestador = false
  }

  async getDocumentoByPrestadorRecebimentoId() {
    this.loadingDocumentoByPrestadorRecebimentoId = true
    const request: any = await this.getFinanceiroStore.getDocumentoByPrestadorRecebimentoId()
    if (request.success) {
      const blob = new Blob([request.data], { type: 'application/pdf' })
      FileSaver.saveAs(blob, `Agrupamento-${new Date().toISOString().substring(0, 10)}.pdf`)
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao fazer o download do agrupamento.', icon: 'warning', color: '#C62828' })
    }
    this.loadingDocumentoByPrestadorRecebimentoId = false
    this.ga('backoffice-financeiro', 'download-agrupamento')
  }

  async showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  async clearAdvancedFilters() {
    this.getFinanceiroStore.clearFiltro()
    this.getFinanceiroStore.setFilterOn(false)
    this.getFinanceiroStore.clearPagePagination()
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
    EventBus.$emit('clearLoadingRequest')
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
    EventBus.$emit('clearLoadingRequest')
  }

  async getItemsResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPageItems = pagina
    const id = this.getFinanceiroStore.itemsId
    await this.getFinanceiroStore.getItensDoRepasse(id)
    EventBus.$emit('clearLoadingRequest')
  }

  formatMotivos(motivos) {
    if (!motivos) return '-'
    const response: string[] = []
    motivos.map((e: any) => response.push(e.display))
    return response.join(', ')
  }

  displayCorSituacao(value: string) {
    return displayColorPrestadorRecebimentoBySituation(value)
  }

  async showModalProvisionarRemuneracao(id: string) {
    this.loadingProvisionarRemuneracao = id
    await timeoutDefault()
    this.modalProvisionarRemuneracao = true
    this.loadingProvisionarRemuneracao = ''
    this.ga('backoffice-financeiro', 'abrir-modal-provisionar-remuneracao')
  }

  async showModalCancelarProvisionamento(id: string) {
    this.loadingCancelarProvisionamento = id
    await timeoutDefault()
    this.modalCancelarProvisionamento = true
    this.loadingCancelarProvisionamento = ''
    this.ga('backoffice-financeiro', 'abrir-modal-cancelar-provisionamento')
  }

  async showModalAlterarPrestador(item: any) {
    this.loadingAlterarPrestador = item.id
    await timeoutDefault()
    this.getFinanceiroStore.setPrestadorRecebimento(item)
    this.modalAlterarPrestador = true
    this.loadingAlterarPrestador = ''
    this.ga('backoffice-financeiro', 'abrir-modal-alterar-prestador')
  }

  @Watch('modalAlterarPrestador')
  onChangeModalAlterarPrestador(value: boolean) {
    if (!value) this.getFinanceiroStore.clearPrestadorRecebimento()
  }

  async showModalDeletarNotaFiscal(id: string) {
    this.loadingDeletarNotaFiscal = id
    await timeoutDefault()
    this.getFinanceiroStore.setDeleteNotaFiscalId(id)
    this.modalDeletarNotaFiscal = true
    this.loadingDeletarNotaFiscal = ''
    this.ga('backoffice-financeiro', 'abrir-modal-deletar-nota-fiscal')
  }

  async showModalEnviarNotificacaoDeCobranca() {
    this.loadingModalEnviarNotificacao = true
    await timeoutDefault()
    this.modalEnviarNotificacaoDeCobranca = true
    this.loadingModalEnviarNotificacao = false
    this.ga('backoffice-financeiro', 'abrir-modal-enviar-notificacao-de-cobranca')
  }

  closeModalEnviarNotificacaoDeCobranca() {
    this.modalEnviarNotificacaoDeCobranca = false
    this.informarEmail = false
    this.email = ''
  }

  async showModalNotificarPrestador(id: string) {
    this.loadingNotificarPrestador = id
    await timeoutDefault()
    this.modalNotificarPrestador = true
    this.loadingNotificarPrestador = ''
    this.ga('backoffice-financeiro', 'abrir-modal-notificar-prestador')
  }

  async closeModalProvisionarRemuneracao() {
    this.novoPrazoNota = ''
    this.previsaoPagamento = ''
    this.$refs.dataNovoPrazoProvisionamento.resetValidation()
    this.$refs.dataNovaPrevisaoPagamento.resetValidation()
    this.modalProvisionarRemuneracao = false
  }

  async closeModalCancelarProvisionamento() {
    this.novoPrazoNotaProvisionada = ''
    this.previsaoPagamentoProvisionada = ''
    this.$refs.provisionadaNovaDataEnvioNota.resetValidation()
    this.$refs.provisionadaNovaDataPagamento.resetValidation()
    this.modalCancelarProvisionamento = false
  }

  async closeModalAlterarPrestador() {
    this.prestador = ''
    this.getFinanceiroStore.clearPrestadoresLista()
    this.modalAlterarPrestador = false
  }

  async closeModalDeletarNotaFiscal() {
    this.modalDeletarNotaFiscal = false
    this.getFinanceiroStore.clearDeleteNotaFiscalId()
  }

  async closeModalNotificarPrestador() {
    this.modalNotificarPrestador = false
    this.dataUltimaNotificacao = ''
    this.$refs.dataNotificacaoForm.resetValidation()
  }

  filterPrestador(items, search, filter) {
    return items.filter(({ prestadorNome }) => {
      const pNome = prestadorNome.toLowerCase()
      const s = search.toLowerCase()
      const f = filter.toLowerCase()
      return pNome.includes(s)
    })
  }

  get icon() {
    if (this.situacao.length === this.situacoes.length) return 'mdi-checkbox-marked'
    if (this.situacao.length > 0) return 'mdi-minus-box'
    return 'mdi-checkbox-blank-outline'
  }

  async selectAll() {
    await this.$nextTick(() => {
      if (this.situacao.length === this.situacoes.length) {
        this.getFinanceiroStore.clearSituacoes()
      } else {
        this.getFinanceiroStore.fillAllSituacoes()
      }

      this.getFinanceiroStore.clearPagePagination()
      this.filterSituacao()
    })
  }

  async selectSituacao(item: any) {
    this.situacao = item
    await this.$nextTick(() => {
      this.filterSituacao()
    })
  }

  async filterSituacao() {
    this.getFinanceiroStore.clearPagePagination()
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
    EventBus.$emit('clearLoadingRequest')
  }

  debounce = _.debounce(input => this.getNotasDebounce(input), 500)

  async searchDebounce(input) {
    this.debounce(encodeURIComponent(input))
  }

  async getNotasDebounce(input: string) {
    this.loadingSearch = true
    this.getFinanceiroStore.setNomePrestador(input)
    this.getFinanceiroStore.clearPagePagination()
    await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
    this.loadingSearch = false
  }

  async clearPrestadorSearch(event: any) {
    if (event) {
      this.loadingSearch = true
      this.getFinanceiroStore.setNomePrestador('')
      this.getFinanceiroStore.clearPagePagination()
      await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
      this.loadingSearch = false
    }
  }

  openModalAgruparRepasses() {
    this.modalAgruparRepasses = true
  }

  openModalExportarRegistros() {
    this.modalExportarRegistros = true
  }

  async emitirRelatorio() {
    this.loadingEmitirRelatorio = true
    const request = await this.getRecebimentoStore.getRelatoriosByFontePagadoraBackoffice()

    if (request.success) {
      this.showModalExportarRegistros = true
    }

    if (!request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não é possível emitir um relatório no momento. Tente novamente mais tarde.', icon: 'warning', color: '#C62828' })
    }

    this.loadingEmitirRelatorio = false
  }

  async getRelatorioRecebimento() {
    this.loadingExportacaoRegistros = true
    if (this.$refs.formExportarRegistros.validate()) {
      const response = await this.getFinanceiroStore.getRelatorioRecebimento(this.fontesPagadorasExportarRegistros)
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Registro exportado com sucesso!', icon: 'done', color: '#2E7D32' })
        this.openExcel(this.getFinanceiroStore.relatorioEmitido)
        this.closeModalExportarRegistros()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possível exportar o registro!', icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingExportacaoRegistros = false
    this.ga('backoffice-financeiro', 'exportar-registros')
  }

  get fontesPagadoras() {
    return this.getRecebimentoStore.fontesPagadoras
  }
  
  get resultadoValidacao() {
    return this.getHistoricoSituacaoStore.validacaoResultado
  }

  get relatorios() {
    if (this.getRecebimentoStore.relatorios.length === 1) {
      this.relatorioSelected = this.getRecebimentoStore.relatorios[0].id
    }
    return this.getRecebimentoStore.relatorios
  }

  async openModalLiberarRepasses() {
    this.modalLiberarRepasses = true
  }

  showModalAlterarSituacoesEmLote() {
    this.modalAlterarSituacoesEmLote = true
  }

  showModalValidacaoResultado() {
    this.modalValidacaoResultado = true
  }

  closeModalAlterarSituacoesEmLote() {
    this.getFinanceiroStore.setAnoMesReferenciaFinalizarProcessos('')
    this.getFinanceiroStore.setFontePagadoraIdFinalizarProcessos('')
    this.getFinanceiroStore.setGrupoRepasseFinalizarProcessos('')
    this.modalAlterarSituacoesEmLote = false
  }

  closeModalValidacaoResultado() {
    this.modalValidacaoResultado = false
  }

  async alterarSituacoesEmLote() {
    this.loadingAlterarSituacoesEmLote = true
    const response = await this.getFinanceiroStore.alterarSituacoesEmLote()
    if (response.success) {
      await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
      this.closeModalAlterarSituacoesEmLote()
      EventBus.$emit('setSnackbar', { show: true, text: 'Situações alteradas com sucesso!', icon: 'done', color: '#2E7D32' })
    }
    this.loadingAlterarSituacoesEmLote = false
    this.ga('backoffice-financeiro', 'alterar-situacoes-em-lote')
  }

  async closeModalAgruparRepasses() {
    this.getFinanceiroStore.setAnoMesReferenciaListaRepasse('')
    this.getFinanceiroStore.setFontePagadoraId('')
    this.$refs.formAnoMesReferencia.reset()
    this.$refs.formAnoMesReferencia.resetValidation()
    this.getFinanceiroStore.clearAgrupamentoRepasse()
    this.modalAgruparRepasses = false
    this.step = 1
  }

  async closeModalExportarRegistros() {
    this.getFinanceiroStore.setAnoMesReferenciaExportarRegistros('')
    this.fontesPagadorasExportarRegistros = []
    this.getFinanceiroStore.setGrupoRepasseExportarRegistros('')
    this.getFinanceiroStore.clearLayoutRelatorio()
    this.modalExportarRegistros = false
    this.step = 1
  }

  closeModalLiberarRepasses() {
    this.modalLiberarRepasses = false
  }

  async salvarNumeroChamado() {
    this.loadingNumeroChamado = true
    if (this.$refs.formNumeroChamado.validate()) {
      const response = await this.getFinanceiroStore.atualizarAgrupamento()
      if (response.success) {
        await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
        this.closeModalAgruparRepasses()
        EventBus.$emit('setSnackbar', { show: true, text: 'Cadastro efetuado com sucesso!', icon: 'done', color: '#2E7D32' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao salvar o número do chamado.', icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingNumeroChamado = false
    this.ga('backoffice-financeiro', 'salvar-numero-chamado')
  }

  formatDateUtil(date: string) {
    return formatDateOnly(date)
  }

  formatMoneyUtil(money: string) {
    return maskMoney(money)
  }

  slaColor(statusSla: StatusSlaEnum) {
    switch (statusSla) {
      case StatusSlaEnum.Normal:
        return 'green'

      case StatusSlaEnum.Alerta:
        return 'yellow'

      case StatusSlaEnum.Critico:
        return 'red'

      default:
        return ''
    }
  }

  situacaoColor(situacao: string) {
    switch (situacao) {
      case 'Validada':
      case 'Paga':
      case 'EnviadoParaPagamento':
        return 'green'

      case 'Pendente':
      case 'ValidacaoPendente':
        return 'orange'

      case 'Divergente':
      case 'Provisionada':
        return 'red'

      default:
        return ''
    }
  }

  async atualizarNotaFiscal(props: any, recebimento: PrestadorRecebimento) {
    this.loadingAtualizarNotaFiscal = recebimento.id
    this.getFinanceiroStore.setAcoesItemRecebimento(props.item.acoes || [])
    this.$refs.tablePrestadores.expanded[recebimento.id] = undefined
    await this.getFinanceiroStore.geRecebimentoById(recebimento.id)
    this.modalAtualizarNotaFiscalDisabled = false
    this.loadingAtualizarNotaFiscal = ''
    this.ga('backoffice-financeiro', 'abrir-modal-atualizar-nota-fiscal')
  }

  async visualizarNotaFiscal(recebimento: PrestadorRecebimento) {
    this.loadingVisualizarNotaFiscal = recebimento.id
    await this.getFinanceiroStore.getVisualizarRecebimento(recebimento.id)
    this.getFinanceiroStore.setModal({ name: 'atualizarNotaFiscal', value: true })
    this.modalAtualizarNotaFiscalDisabled = true
    this.loadingVisualizarNotaFiscal = ''
    this.ga('backoffice-financeiro', 'abrir-modal-visualizar-nota-fiscal')
  }

  async provisionarRemuneracao(prestadorRecebimentoId: string) {
    this.loadingProvisionarConfirmar = true
    const params: any = {
      novoPrazoEnvioNota: this.novoPrazoNota,
      novaPrevisaoRecebimento: this.previsaoPagamento,
      prestadorRecebimentoId,
    }
    if (this.$refs.dataNovoPrazoProvisionamento.validate() && this.$refs.dataNovaPrevisaoPagamento.validate()) {
      const response = await this.getFinanceiroStore.provisionarRemuneracao(params)
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Repasse provisionado com sucesso!', icon: 'done', color: '#2E7D32' })
        this.getFinanceiroStore.atualizaStatusParaProvisionada(prestadorRecebimentoId)
        this.getFinanceiroStore.atualizaDataPrevisaoPagamento(params)
        this.closeModalProvisionarRemuneracao()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message ? response.message : 'Ocorreu um erro ao provisionar o repasse.', icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingProvisionarConfirmar = false
    this.ga('backoffice-financeiro', 'provisionar-remuneracao')
  }

  async cancelarProvisionamentoRemuneracao(prestadorRecebimentoId: string) {
    this.loadingCancelarProvisionamentoConfirmar = true
    const params: any = {
      novoPrazoEnvioNota: this.novoPrazoNotaProvisionada,
      novaPrevisaoRecebimento: this.previsaoPagamentoProvisionada,
      prestadorRecebimentoId,
    }
    if (this.$refs.provisionadaNovaDataEnvioNota.validate() && this.$refs.provisionadaNovaDataPagamento.validate()) {
      const response = await this.getFinanceiroStore.cancelarProvisionamentoRemuneracao(params)
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Provisionamento cancelado com sucesso!', icon: 'done', color: '#2E7D32' })
        this.getFinanceiroStore.atualizaStatusParaPendente(prestadorRecebimentoId)
        this.getFinanceiroStore.atualizaDataPrevisaoPagamento(params)
        this.closeModalCancelarProvisionamento()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message ? response.message : 'Ocorreu um erro ao cancelar o provisionamento.', icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingCancelarProvisionamentoConfirmar = false
    this.ga('backoffice-financeiro', 'cancelar-provisionamento-remuneracao')
  }

  async notificarPrestador(prestadorRecebimentoId: string) {
    this.loadingNotificarConfirmar = true
    if (this.$refs.dataNotificacaoForm.validate()) {
      const response = await this.getFinanceiroStore.notificarManualmenteRecebimento({ prestadorRecebimentoId, dataNotificacaoManual: moment(this.dataUltimaNotificacao).format('YYYY-MM-DD') })
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Notifcação realizada com sucesso!', icon: 'done', color: '#2E7D32' })
        this.getFinanceiroStore.atualizarDataNotificacao({ prestadorRecebimentoId, dataNotificacaoManual: this.dataUltimaNotificacao })
        this.closeModalNotificarPrestador()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message ? response.message : 'Ocorreu um erro na notificação.', icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingNotificarConfirmar = false
    this.ga('backoffice-financeiro', 'notificar-prestador')
  }

  async deletarNotaFiscal() {
    this.loadingDeletarConfirmar = true
    const response = await this.getFinanceiroStore.deletarNotaFiscal()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Nota fiscal deletada com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
      this.closeModalDeletarNotaFiscal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message ? response.message : 'Ocorreu um erro na notificação.', icon: 'warning', color: '#C62828' })
    }
    this.loadingDeletarConfirmar = false
    this.ga('backoffice-financeiro', 'deletar-nota-fiscal')
  }

  async searchPrestador() {
    if (this.prestador.length < 3) return
    this.loadingSearchPrestador = true
    await this.getFinanceiroStore.getPessoaPrestadorAll({ limite: 20, filtro: encodeURIComponent(this.prestador) })
    if (this.getFinanceiroStore.prestadoresLista.length === 0) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Nenhum prestador encontrado.', icon: 'warning', color: '#C62828' })
    }
    this.loadingSearchPrestador = false
  }

  async alterarPrestador() {
    this.loadingAlterarPrestadorConfirmar = true

    if (!this.selected.userId) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Selecione um prestador.', icon: 'warning', color: '#C62828' })
      this.loadingAlterarPrestadorConfirmar = false
      return
    }
    
    const params = {
      prestadorRecebimentoId: this.prestadorRecebimento.id,
      prestadorId: this.selected.userId,
    }
    const response = await this.getFinanceiroStore.alterarPrestador(params)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Prestador alterado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.getFinanceiroStore.getPrestadorRemuneracaoAll()
      this.closeModalAlterarPrestador()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message ? response.message : 'Ocorreu um erro na alteração.', icon: 'warning', color: '#C62828' })
    }
    this.loadingAlterarPrestadorConfirmar = false
    this.ga('backoffice-financeiro', 'alterar-prestador')
  }

  @Watch('prestador')
  async onChangePrestador(value: any) {
    if (value.length < 3) {
      this.getFinanceiroStore.clearPrestadoresLista()
      this.selected = {}
    }
  }

  @Watch('informarEmail')
  onChangeModalEnviarNotificacaoDeCobranca(value: boolean) {
    if (value) {
      this.email = ''
    }
  }

  @Watch('showModalExportarRegistros')
  onChangeModalExportarRegistros(value: boolean) {
    if (!value) {
      this.getRecebimentoStore.clearExportarRegistros()
      this.relatorioSelected = ''
      this.situacoesExportarRegistros = ''
      this.fontesPagadorasExportarRegistros = []
      this.$refs.formExportarRegistros.resetValidation()
    }
  }

  get getHistoricoSituacaoStore() {
    return getModule(HistoricoSituacaoStore, this.$store)
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    await this.getHistoricoSituacaoStore.getHistoricoSituacao(solicitacaoId)
    await this.getHistoricoSituacaoStore.getHistoricoGeracaoRepasse(solicitacaoId)
    this.loadingHistorico = ''
    this.ga('backoffice-financeiro', 'historico-situacao')
  }

  async showValidacaoResultado(prestadorRecebimentoId: string) {
    this.loadingValidacaoResultado = prestadorRecebimentoId
    const response = await this.getHistoricoSituacaoStore.getValidacaoResultado(prestadorRecebimentoId)
    if (response.success) {
      this.showModalValidacaoResultado()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message ? response.message : 'Ocorreu um erro ao buscar a validação do resultado.', icon: 'warning', color: '#C62828' })
    }
    this.loadingValidacaoResultado = ''
  }

  async deleteRepasse(solicitacaoId: string) {
    this.loadingOpenModalDelete = solicitacaoId
    await timeoutDefault()
    this.solicitacaoId = solicitacaoId
    this.modalDeleteRepasse = true
    this.loadingOpenModalDelete = ''
  }

  closeModalDeleteRepasse() {
    this.modalDeleteRepasse = false
  }

  async deletarRepasse() {
    this.loadingDeleteRepasse = true
    const response = await this.getFinanceiroStore.deletarRepasse()
    if (response.success) {
      await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
      this.closeModalDeleteRepasse()
      EventBus.$emit('setSnackbar', { show: true, text: 'Repasse deletado com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message ? response.message : 'Ocorreu um erro ao deletar o repasse.', icon: 'warning', color: '#C62828' })
    }
    this.loadingDeleteRepasse = false
    this.ga('backoffice-financeiro', 'deletar-repasse')
  }

  getWrapper() {
    return this.$refs.tablePrestadores.$el.querySelector('.v-table__overflow')
  }

  scrollLeft() {
    const el = this.getWrapper()
    if (el) {
      el.scrollBy({ left: -400, behavior: 'smooth' })
      this.$nextTick(this.updateArrows)
    }
  }

  scrollRight() {
    const el = this.getWrapper()
    if (el) {
      el.scrollBy({ left: 400, behavior: 'smooth' })
      this.$nextTick(this.updateArrows)
    }
  }
  
  updateArrows() {
    const el = this.getWrapper()
    if (!el) return
    const scrollLeft = el.scrollLeft
    const maxScroll = el.scrollWidth - el.clientWidth
    const hasOverflow = el.scrollWidth > el.clientWidth
    this.showLeft = hasOverflow && scrollLeft > 0
    this.showRight = hasOverflow && scrollLeft < maxScroll - 1
  }

  hasMedicos(nomes: Array<string> | null | undefined) {
    return Array.isArray(nomes) && nomes.length > 0
  }

  labelHeaderResponsavel(nomes: Array<string> | null | undefined){
    return !this.hasMedicos(nomes) ? 'Responsável' : 'Profissional';
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getRecebimentoStore.getFontePagadoraAll()
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()

    this.$nextTick(() => {
     const wrapper = this.getWrapper()
      if (wrapper) {
        wrapper.addEventListener('scroll', this.updateArrows)
        this.updateArrows()
      }
    })
  }

  beforeDestroy() {
    this.getFinanceiroStore.clearFiltro()
    this.getFinanceiroStore.clearSituacoes()
    this.getFinanceiroStore.clearPrestadoresLista()
    this.selected = {}
  }
}
